import React, { useEffect } from 'react';
import Page from 'src/components/Page';
import './index.css';
import EventEmitter from 'src/utils/EventEmitter';
import ProductPopupView from 'src/views/Movements/ProductPopup';
import AcknowledgeMovementPopup from 'src/views/Movements/AcknowledgeMovementPopup';
import RegisteredTGAApprovalsView from 'src/views/Sales/RegisteredTGAApprovals';
import PrescriberProductPopupView from 'src/views/Sales/PrescriberProductPopup';
import UploadSalesPopup from 'src/views/Sales/UploadSales/UploadSalesPopup';

const PopupCustomView = (props) => {
  const type = props ? props.popupType : "";
  const customData = props ? props.customData : "";
  let width = 876;

  var page_title = "";
  if (type === "cart") {
    page_title = "Cart";
  } else if (type === "product") {
    page_title = "Product";
  } else if (type === "business" || type === "primary-contact" || type === "billing-contact" || type === "pay-invoice") {
    page_title = "Accounts";
  } else if (type === "tga") {
    page_title = "My Prescribers";
  } else if (type === "tga-registered") {
    page_title = "Registered TGA Approvals";
  } else if (type === "add-product") {
    page_title = "Catalogue";
  } else if (type === "upload-sales") {
    page_title = "Cannatrek Consignment Hub";
  } else if (type === "movement") {
    page_title = "Acknowledge Movement";
    width = 792;
  } else if (type === "order") {
    page_title = "Order";
    width = 792;
  }

  useEffect(() => {
    const onClickPrevStep = () => {
      onClickBackArrow();
    }

    const listener = EventEmitter.addListener('prev_step', onClickPrevStep);

    return () => {
      listener.remove();
    }
  }, []);

  const onClickBackArrow = () => {
    EventEmitter.emit("show_custom_popup", { value: false });
  }

  return (
    <Page title={page_title} className="custom-popup-container">
      <div className="main-wrapper" style={{ height: "100%" }}>
        <div className="custom-popup-wrapper-container" style={{ "--width": width + "px" }}>
          <div className="custom-popup-container-2" style={{ height: "100%", marginTop: "0px" }}>
            {
              type === "order" ?
                <ProductPopupView customData={customData} /> :
                type === "movement" ?
                  <AcknowledgeMovementPopup customData={customData} /> :
                  type === "tga-registered" ?
                    <RegisteredTGAApprovalsView customData={customData} /> :
                    type === "upload-sales" ?
                      <UploadSalesPopup customData={customData} /> :
                      type === "prescriber-product" ?
                        <PrescriberProductPopupView customData={customData} /> :
                        <div className="custom-popup-container-wrapper" style={{ height: "100%", rowGap: "70px" }}>
                          <div className="custom-popup-container-wrapper-header"></div>
                        </div>
            }
          </div>
        </div>
      </div>
    </Page>
  );
}

export default PopupCustomView;